module.exports = __webpack_public_path__ + "img/chr_ts_90_10.948fc8cf.png";